export default __webpack_public_path__ + "static/media/planarock-top-rockwool-komposition_comp.10726af0.jpg";